import { DeliveryDiscountType, PickupDiscountType } from '@client/graphql/types/graphql.ts';

export function pickupDiscountTypeName(type: PickupDiscountType): string {
  switch (type) {
    case PickupDiscountType.None:
      return 'Disable';
    case PickupDiscountType.Percentage:
      return 'Percentage';
    case PickupDiscountType.Amount:
      return 'Amount';
  }
}

export function deliveryDiscountTypeName(type: DeliveryDiscountType): string {
  switch (type) {
    case DeliveryDiscountType.None:
      return 'Disable';
    case DeliveryDiscountType.Percentage:
      return 'Percentage';
    case DeliveryDiscountType.Amount:
      return 'Amount';
  }
}